import React from 'react';

import {
    Link
} from 'react-router-dom';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';
import { JSONToCSVConvertor } from '../Helpers/ExportToExcel';
import config from '.././config.json';
import $ from 'jquery';

import '../App.css';

class Admin extends React.Component {
    constructor(props) {
        super(props);
    }

    state = ({
        login: true
    });
    /**
     * Render Function
     */
    render() {
        return (
            <div >
                {this.state.login ?
                    <div>
                        <div className="col-xs-6">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h2>Class Management</h2>
                                </div>
                                <div className="panel-body">
                                    {/*Add Class*/}
                                    <li  >
                                        <Link to="/admin/add" onClick={() => {

                                        }} replace >Add Classes/Duplicate New Classes</Link>
                                    </li>
                                    {/*Search Class*/}
                                    <li  >
                                        <Link to="/admin/editclass" onClick={() => {
                                        }} replace>Search/Edit Classes</Link>
                                    </li>
                                    {/*Grade Class*/}
                                    <li>
                                        <Link to="/admin/grade" onClick={() => {
                                        }} replace>Manage Class List</Link>
                                    </li>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h2>Student Management</h2>
                                </div>
                                <div className="panel-body">
                                    {/*Register Students*/}
                                    <li  >
                                        <Link to="/admin/register" onClick={() => {
                                        }}>Register Students</Link>
                                    </li>
                                    {/*Register multiple Students*/}
                                    <li  >
                                        <Link to="/admin/registerMultiple" onClick={() => {
                                        }}>Multiple Students registration</Link>
                                    </li>
                                    {/*Assign Certification to Students*/}
                                    <li  >
                                        <Link to="/admin/assigncert" onClick={() => {
                                        }}>Assign Certification</Link>
                                    </li>
                                    {/*Search/Edit Students*/}
                                    <li  >
                                        <Link to="/admin/editattendee" onClick={() => {
                                        }}>Search/Edit Students</Link>
                                    </li>
                                    {/*Search student history*/}
                                    <li >
                                        <Link to="/admin/searchStudentHistory"> Search Student History </Link>
                                    </li>
                                    {/*Email Class*/}
                                    <li  >
                                        <Link to="/admin/email" onClick={() => {
                                        }}>Email Class</Link>
                                    </li>
                                    {/*Change Class*/}
                                    <li >
                                        <Link to="/admin/change">Change Classes</Link>
                                    </li>
                                    {/*Student Payment*/}
                                    <li >
                                        <Link to="/admin/payment">Payment Manager</Link>
                                    </li>
                                    {/*Add Employer*/}
                                    <li >
                                        <Link to="/admin/addemployer" >Add/Edit Employer</Link>
                                    </li>
                                    <li >
                                        <Link to="/admin/admin" onClick={() => { this.exportEmployerExcel(); }} >Export Employers to Excel</Link>
                                    </li>
                                    <li >
                                        <Link to="/admin/import" >Import Students from Excel (TCP only)</Link>
                                    </li>
                                    {/*<li >
                            <Link to="/admin/merge" >Merge Students</Link>
                        </li> Hide since this is not fleshed out.*/}
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h2>ESCC Certification</h2>
                                </div>
                                <div className="panel-body">
                                    {/*Add Class*/}
                                    <li  >
                                        <Link to="/admin/addescc">Add/Edit ESCC Certification</Link>
                                    </li>
                                    {/*Search Class*/}
                                    <li  >
                                        <Link to="/admin/assignescc">Assign ESCC Certification</Link>
                                    </li>
                                </div>
                            </div>
                        </div>
                        {/*
                <div className="col-xs-6">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h2>External Civil Rights Certifications</h2>
                        </div>
                        <div className="panel-body">
                        <li  >
                            <Link to="/admin/addecrt">Add/Edit Civil Rights Certification</Link>
                        </li>
                        <li  >
                            <Link to="/admin/assignecrt">Assign Civil Rights Certification</Link>
                        </li>
                    </div>
                    </div>
                </div >
                            */}

                    </div >
                    : <Redirect to="/login" replace />
                }
            </div>
        );
    }

    //Returns true or false if an admin is logged in.
    //This is based on looking at the url and seeing
    //if the word admin is there.
    static isAdminLoggedIn() {

        var url = window.location.href;
        //Look for the word admin in the url
        var searchForAdmin = url.search("admin");
        //If the word returns -1, means there is no match.
        if (searchForAdmin == -1) {
            return false;
        }
        //The word admin was found.
        else {
            return true;
        }
    }

    exportEmployerExcel() {
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getallemployer`,
        })
            .done((data) => {
                console.log(data)
                JSONToCSVConvertor(data, 'Employers', true, 'text/csv;encoding:utf-8');
            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });

    }

    componentDidMount() {
        LoginForm.ValidateServerToken(() => { this.setState({ login: false }) });
    }
}


//const WrappedNormalLoginForm = Form.create()(Admin);

export default Admin;



// WEBPACK FOOTER //
// ./src/Admin/Admin.js